import type { Block } from '../../../../types/proposal-blocks';

type Data = Extract<Block, { type: 'numbered_cards' }>;

interface Props {
  block: Data;
  onNavigate?: (anchor: string) => void;
}

export function NumberedCardsBlock({ block, onNavigate }: Props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      {block.cards.map((card, i) => (
        <article
          key={i}
          onClick={() => card.anchor && onNavigate?.(card.anchor)}
          className="bg-proposal-bg2 border border-proposal-border rounded-p-lg p-5 cursor-pointer transition-all hover:border-proposal-border-strong hover:bg-proposal-bg3 hover:-translate-y-px"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && card.anchor && onNavigate?.(card.anchor)}
        >
          <span className="font-proposal-mono text-[11px] font-medium text-proposal-fg3 mb-2.5 block">
            {card.number}
          </span>
          <h3 className="text-[13px] font-semibold text-proposal-fg1 mb-1.5 leading-snug">
            {card.title}
          </h3>
          <p className="text-[12px] text-proposal-fg2 leading-relaxed">
            {card.description}
          </p>
        </article>
      ))}
    </div>
  );
}
